// extracted by mini-css-extract-plugin
export default {"chart-container":"PieChart_chart-container__yPBsv"};